export const PageIntro = ({ eyebrow, title, children, testid }) => (
  <section className="relative overflow-hidden">
    <div className="absolute -top-24 -right-24 h-80 w-80 rounded-full bg-[#b1cc90]/30 blur-3xl breathe" />
    <div className="absolute top-40 -left-24 h-64 w-64 rounded-full bg-[#b6689a]/15 blur-3xl breathe" />
    <div className="relative max-w-5xl mx-auto px-6 lg:px-10 pt-24 pb-16">
      {eyebrow && <span className="eyebrow rise">{eyebrow}</span>}
      <h1 data-testid={testid} className="font-serif-h font-light text-4xl sm:text-5xl lg:text-6xl text-[#577731] leading-[1.1] mt-4 rise d1">
        {title}
      </h1>
      <div className="mt-8 text-base sm:text-lg leading-relaxed text-[#232b1b]/80 max-w-3xl space-y-5 rise d2">{children}</div>
    </div>
  </section>
);
